export * from './triangle-loader'
